import React from "react";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "../lib/data";

export default function WhatsAppFloat() {
    return (
        <motion.a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-float"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
            className="fixed bottom-6 left-6 z-40 w-16 h-16 rounded-full flex items-center justify-center text-white text-3xl"
            style={{
                background: "linear-gradient(135deg, #25D366, #128C7E)",
                boxShadow: "0 10px 30px -5px rgba(37, 211, 102, 0.6)",
            }}
            whileHover={{ scale: 1.08 }}
        >
            <span className="absolute inset-0 rounded-full animate-ping opacity-30" style={{ background: "#25D366" }} />
            <i className="fa-brands fa-whatsapp relative" />
        </motion.a>
    );
}
